export default async function injectStoreConfiguration ({ ssrContext, app }) {
  if (ssrContext) {

    /**
     * Makes baseStore configuration accessible both server and client-side
     */
    const baseStoreConfiguration = await app.$vsf.$sapcc.api.getBaseStore({});

    Object.defineProperty(
      app.$vsf.$sapcc.config,
      'baseStoreConfiguration',
      { value: baseStoreConfiguration, enumerable: true }
    );

    Object.defineProperty(
      ssrContext.runtimeConfig.public,
      'baseStoreConfiguration',
      { value: baseStoreConfiguration, enumerable: true }
    );
    return;
  }

  /**
   * Saves the configuration in $sapcc client-side context and clears it from
   * publicRuntimeConfig
   */
  const baseStoreConfiguration = app.$config.baseStoreConfiguration;

  Object.defineProperty(
    app.$vsf.$sapcc.config,
    'baseStoreConfiguration',
    { value: baseStoreConfiguration, enumerable: true }
  );

  delete app.$config.baseStoreConfiguration;
}
